import React, { useEffect,useContext,useState } from "react";
import Context from '../_helpers/context';
import {  Button, Modal } from 'react-bootstrap';
const lang = require('./lang/lang.json')


export default function Step_cerco(props) {

  const context = useContext(Context)
  const locale = context.lang

  function handleInputChange(target) {

        var value = target;
        context.user_form.cerco = value
        props.onStep()
  }



  return (
    <div className="buttons_cerco" style={{display:"flex", flexDirection:"row", justifyContent:"center", alignItems:"center"}}>
       <Button style={{margin:"0 10px",fontSize:"20px",letterSpacing:"5px"}} onClick={() => { handleInputChange("donna")}}>DONNE</Button>
       <Button style={{margin:"0 10px",fontSize:"20px",letterSpacing:"5px"}} onClick={() => { handleInputChange("uomo")}}>UOMINI</Button>
    </div>
  );
}